import { render, staticRenderFns } from "./PackagePondDetail.vue?vue&type=template&id=626cbcd0&scoped=true&"
import script from "./PackagePondDetail.vue?vue&type=script&lang=js&"
export * from "./PackagePondDetail.vue?vue&type=script&lang=js&"
import style0 from "./PackagePondDetail.vue?vue&type=style&index=0&id=626cbcd0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626cbcd0",
  null
  
)

export default component.exports